import { jwtDecode } from "jwt-decode"

export function getUserIdFromJWT(token: string) {
  const decoded = jwtDecode<{ id: string }>(token)
  const id = decoded?.id ?? null
  return id
}

export function getAccountIdFromJWT(token: string) {
  const decoded = jwtDecode<{ accountId: string }>(token)
  const id = decoded?.accountId ?? null
  return id
}
